import styled from "styled-components";

import { FlexContainer, FlexSection } from "@/components/Atoms/Box";

import theme from "@/foundation/Theme";

export const PageWrapper = styled(FlexSection)`
  background-color: ${theme.colorsV2.shyft.cream};
`;

export const PageContainer = styled(FlexContainer)`
  gap: 60px;
  padding: 100px 16px 60px;
  @media only screen and (max-width: 600px) {
    flex-direction: column;
    gap: 0px;
    padding: 0px 0px 32px 0px;
  }
`;
